<template>
  <section class="about-app-store">
    <div class="about-app-store__contents">
      <div class="about-app-store__content">
        <GifteeAppIcon class="about-app-store__giftee-app-icon" />
        <p class="about-app-store__text">
          <span>アプリでもっと気軽にギフトを贈ろう</span>
          <span>ダウンロードはこちら</span>
        </p>
        <div class="about-app-store__app-buttons">
          <a
            href="https://play.google.com/store/apps/details?id=co.giftee.app&utm_source=about"
            class="about-app-store__google-play"
          >
            <ImgLazy
              :image-url="PlayStoreIcon"
              alt-text="Google Play Store"
              aspect-ratio="18 / 7"
              :width="180"
              :height="70"
              class="about-app-store__app-image"
            />
          </a>
          <a
            href="https://itunes.apple.com/us/app/giftee/id508754185?l=ja&ls=1&pt=999334&ct=about&mt=8
"
            class="about-app-store__app-store"
          >
            <ImgLazy
              :image-url="AppStoreIcon"
              alt-text="App Store"
              aspect-ratio="130 / 48"
              :width="130"
              :height="48"
              class="about-app-store__app-image"
            />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import AppStoreIcon from '../../../../../../images/abouts/app_store/Download_on_the_App_Store_Badge_JP_RGB_blk_100317.svg'
import PlayStoreIcon from '../../../../../../images/abouts/app_store/google-play-badge.png'
import GifteeAppIcon from '../../../atoms/icons/GifteeAppIcon.vue'
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
</script>

<style lang="scss" scoped>
.about-app-store {
  background-color: $white;
  display: flex;
  justify-content: center;
  padding: 96px 72px;

  @media all and (max-width: ($pc-width  - 1)) {
    padding: 56px 24px;
  }

  &__contents {
    margin: auto;
    display: flex;
    justify-content: left;
    align-items: center;
    width: 100%;
    max-width: 1040px;
    height: 400px;
    background-color: $white;
    background-position: right center;
    background-image: url('../../../../../../images/abouts/app_store/app_image.png');
    background-repeat: no-repeat;
    background-size: 100%;
    border-radius: 16px;

    @media all and (max-width: ($pc-width  - 1)) {
      background: $white;
      justify-content: center;
      height: auto;
    }
  }

  &__content {
    width: max-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  &__giftee-app-icon {
    width: 80px;
    height: 80px;

    @media all and (max-width: ($pc-width  - 1)) {
      padding-bottom: 16px;
    }
  }

  &__text {
    font-weight: bold;
    font-size: 1.8rem;
    line-height: 1.6;
    letter-spacing: 0.06em;
    color: $black;

    > span {
      display: block;
    }

    @media all and (max-width: ($pc-width  - 1)) {
      font-size: 1.6rem;
    }
  }

  &__app-buttons {
    display: flex;
    align-items: center;
    gap: 24px;

    @media all and (max-width: ($pc-width  - 1)) {
      gap: 0px;
    }
  }

  &__app-store {
    padding-right: 12px;
  }

  &__app-image {
    @extend %hover-common;
  }
}
</style>
